<template>
    <v-container class="text-xs-center"> 
        <div class="results-count">{{services.length}} Risultati</div>
        <v-layout row wrap justify-center :class="multiselect?'multiselecting':'not-multiselecting'">
            <v-flex xs12 md10>
                <v-card 
                    v-for="service in services" :key="service.id" 
                    @click="serviceClicked(service)"
                    :style="{backgroundColor: service.color }"
                >
                    <v-card-text>
                        <div class="card-checkbox" v-if="multiselect"><v-icon>check</v-icon></div>
                        <div class="inline-block" style="max-width: calc(100% - 70px);">
                            <strong>{{service.category}} &gt; {{service.name}}</strong><br>
                            Durata: {{service.time}}<br>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'Services',
    data: function(){
        return{
            services: [],
            multiselect: false,
        };
    },
    mounted: function(){
        let vm = this;
        vm.getServices();
    },
    methods:{
        getServices(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getServices.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.services = [];
                    vm.services = response.data.resources;
                } 
                else{
                    alert("Si è verificato un errore durante il caricamento");
                }
            })
            .catch(function (error) {
                if(error.response.status==403||error.response.status==401){
                    vm.$router.push({name: 'login'});
                }
                else{
                    alert("Si è verificato un errore durante il caricamento");
                    console.error(error)
                }
            });
        }
    }
}
</script>
